/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */
import _, {isEmpty} from 'lodash';
import ForceNewsBlockWrapper from '@/components/common/news/ForceNewsBlockWrapper';
import {fileCustomerNameDuplicateValidation, fileSizeValidation, fileTypeValidation} from '@/common/helpers/validation';
import $ from 'jquery';
import store from '@/store/index';
import IConstants from "@/common/constants/IConstants.js";
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers("editProfile")
const {mapGetters: mapForceNewGetters} = createNamespacedHelpers('forceNews');


const PLEASE_SELECT_VALUE = '-1';

const formMixin = {
    components: {ForceNewsBlockWrapper},
    props: {
        inputProp: {
            type: Object,
            required: true
        },
        parentScreen: {
            type: String,
            required: false,
            default: 'force-news'
        },
        requireCharacters: {
            required: false,
            default: false
        },
        blockName: {
            type: String,
            required: false
        },
        toggleButtonType: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            input: null,
        }
    },
    computed: {
        ...mapState({
            masterInput: state => state.masterInput,
            activeBlock: state => state.activeBlock
        }),
        ...mapForceNewGetters(['getForceNewsCustomerInfoView']),
        namespace() {
            return this.parentScreen === IConstants.PARENT_SCREEN.FORCE_NEWS ? 'forceNews' : 'editProfile';
        },
        isDisabledButtonSubmit() {
            const {$v} = this;
            const redundantProperties = ['amsCustomerDetail.currentPassword',
                'amsCustomerDetail.beneficOwnerFlg',
                'amsCustomerDetail.beneficOwnerFlg2',
                'amsCustomerDetail.beneficOwnerFlg3',
                'amsCustomerDetail.beneficOwnerFlg4']
            const masterInput = JSON.parse(this.masterInput);
            const masterInputOmit = _.omit(masterInput, redundantProperties);
            const inputOmit = _.omit(this.input,redundantProperties);
            const hasNotChangeInput = this.masterInput && JSON.stringify(masterInputOmit) === JSON.stringify(inputOmit);

            return $v.$anyError || hasNotChangeInput;
        },
        isParentScreenEditProfile() {
            return this.parentScreen === IConstants.PARENT_SCREEN.EDIT_PROFILE;
        },
        isParentScreenForceNew() {
            return this.parentScreen === IConstants.PARENT_SCREEN.FORCE_NEWS;
        }
    },
    watch: {
        inputProp: {
            handler(val) {
                if (!isEmpty(val)) {
                    this.input = val
                }
            },
            deep: true,
            immediate: true,
        },
        "$v.$invalid": function () {
            if (this.parentScreen === IConstants.PARENT_SCREEN.FORCE_NEWS)
                this.$emit("onChangeChildFormStatus", this.$v.$invalid, this.blockName);
        },

    },
    methods: {
        removeInputFile() {
            $('.custom-file').each(function () {
                const buttonFileGroup = $(this).next()
                if (buttonFileGroup.length > 0) {
                    buttonFileGroup.find('button:last-child').trigger('click');
                }
            })
        },
        getInitFileValidation(initData, keysExclude = [], initValidationValue = {fileTypeValidation, fileSizeValidation}, isValidDuplicateFileName) {
            const initValidateData = {};
            keysExclude.push("input");
            Object.keys(initData).map(function (key) {
                if (!keysExclude.includes(key)) {
                    if (isValidDuplicateFileName) {
                        initValidationValue = {
                            ...initValidationValue,
                            fileCustomerNameDuplicateValidation: fileCustomerNameDuplicateValidation(key)
                        }
                    }
                    initValidateData[key] = initValidationValue
                }
            });
            return initValidateData;
        },
        reverseInput(blockId) {
            this.removeInputFile();
            const block = blockId ? blockId : '';
            store.dispatch('editProfile/setActiveBlock', block);
            store.dispatch('editProfile/reverseInput');
            this.$v.$reset();
        },
        getButtonType(){
            return this.activeBlock === this.toggleButtonType ? "submit" : "button";
        },
        calculateInvestmentAmountValues(financialAssetsValue) {
            let values = _.cloneDeep(IConstants.LIST_FINAL_ASSETS);
            if (financialAssetsValue != PLEASE_SELECT_VALUE) {
                return values.filter(
                    (item) => item.key <= financialAssetsValue
                );
            }

            return values;
        },
        checkNonCaseSensitiveExistingEmail(oldMail, newMail){
            if(oldMail && newMail && (oldMail !== newMail)){
                return oldMail.toLowerCase() !==  newMail.toLowerCase();
            }
            return true;
        }

    },
}
export default formMixin;
